module.exports = __webpack_public_path__ + "img/login-right-img.d06e93f1.png";